import React from "react";
import { Link } from "react-router-dom";
import style from '../style.module.scss';
import logo from '../../../../assets/img/logo.svg';

import { ROUTE_DASHBOARD } from "../../../../config/routes";
// Translate
import { Translation  } from 'react-i18next';
import { TFunction } from "../../../../utils/tlumacz";

class Error404 extends React.Component {
    render(): React.ReactNode {
        return (
            <div className={style.errors}>
                <Translation ns={'template'}>
                    {(t: TFunction) => (
                        <>
                            <div className="pt-4 pb-4 d-flex align-items-end mt-auto">
                                <img src={logo} alt="Logo" />
                            </div>
                            <div className={`${style.container} pl-5 pr-5 pt-5 pb-5 mb-auto text-dark font-size-30`}>
                                <div className="font-weight-bold mb-3">{t('error_404_title')}</div>
                                <div>{t('error_404_info')}</div>
                                <div className="font-weight-bold font-size-70 mb-1">404 —</div>
                                <Link to={ROUTE_DASHBOARD} className="btn btn-outline-primary width-100">
                                    {t('back')}
                                </Link>
                            </div>
                        </>
                    )}
                </Translation>
            </div>
        );
    }
}

export default Error404;
